import React, { Fragment, useEffect, useState } from "react";
import { decodeToken } from "react-jwt";

import { useStore } from "../../hook-store/store";
import { setLoginExtendToken } from "../../util/user";

import { BASE_URL } from "../../App";

const LoginExtendToken = (props) => {
  // const {  } = props;

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  // useEffect(() => {
  //   let extendInterval;

  //   if (isAuth) {
  //     const loginExtendTokenHandler = () => {
  //       const tokenExpireTime = new Date(localStorage.getItem('expiryDate')).getTime();
  //       // console.log('tokenExpireTime', tokenExpireTime);
  //       if (tokenExpireTime < Date.now() + 1000*60*60*24*300) {
  //         createLoginExtendToken(
  //           BASE_URL,
  //           localStorage.getItem("token"),
  //           localStorage.getItem('userId'),
  //         );
  //       }
  //     };

  //     loginExtendTokenHandler();

  //     extendInterval = setInterval(() => {
  //       loginExtendTokenHandler();
  //     }, 1000*60*60);

  //   }


  //   return () => {
  //     if (extendInterval) {
  //       clearInterval(extendInterval);
  //     }
  //   }
  // }, [isAuth]);


  useEffect(() => {
    if (isAuth) {
      const lsTokenDecoded = decodeToken(localStorage.getItem('token'));
      console.log('lsTokenDecoded', lsTokenDecoded);

      // console.log('token iat', new Date(lsTokenDecoded.iat*1000))
      // console.log('token exp', new Date(lsTokenDecoded.exp*1000))

      const after7daysIssueTime = lsTokenDecoded.iat*1000 + 1000*60*60*24*7;
      // const after7daysIssueTime = lsTokenDecoded.iat*1000;
      
      const tokenExpireTime = lsTokenDecoded.exp*1000;

      if (Date.now() > after7daysIssueTime && Date.now() < tokenExpireTime) {
        createLoginExtendToken(
          BASE_URL,
          localStorage.getItem("token"),
          localStorage.getItem('userId'),
        );
      }
    }

  }, [isAuth]);

  const createLoginExtendToken = (url, token, userId) => {
    //// check auth validity and logout
      fetch(url + "/auth/login-extend-token", {
        method: 'POST',
        headers: {
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          userId: userId,
        }),
      })
        .then((res) => {
          console.log(res);
  
          if (!res.ok) {
            throw new Error("error occured.");
          }
          return res.json();
        })
        .then((resData) => {
          console.log(resData);

          if (resData.data && resData.data.loginExtendToken) {
            setLoginExtendToken(resData.data.loginExtendToken);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    
  };

  return <Fragment></Fragment>;
};

export default LoginExtendToken;
